var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _vm._l(_vm.tableList, function (round, index) {
        return _vm.showRound(round)
          ? _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _vm._v("Round " + _vm._s(round.roundNumber) + " "),
                    _vm.ssr.owned
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.goMark(round.ttSsrRoundId)
                              },
                            },
                          },
                          [_vm._v("Score")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    ref: "table",
                    refInFor: true,
                    staticStyle: { "margin-top": "15px" },
                    attrs: {
                      data: round.ssrRoundSuppliers.filter(
                        (sup) => sup.status != "REFUSE"
                      ),
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "supplierCode",
                        label: "Supplier Code",
                        width: "170",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "supplierName",
                        label: "Supplier Name For Short",
                        "min-width": "140",
                      },
                    }),
                    _vm._l(_vm.scoreItems, function (item) {
                      return _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          label: item,
                          width: item.length * 15,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.markInfo.scoreMap[item])
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        label: "Total Score",
                        width: "200",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return scope.row.markInfo != null &&
                                scope.row.markInfo.totalScoreSs != null
                                ? [
                                    !_vm.isSupplier
                                      ? _c(
                                          "el-link",
                                          {
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.goMark(
                                                  round.ttSsrRoundId
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.markInfo.totalScoreSs
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.isSupplier
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.markInfo.totalScoreSs
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    scope.row.markInfo.shareFlag == "N" &&
                                    _vm.ssr.owned
                                      ? _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "1em",
                                            },
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                              title: _vm.$t(
                                                "ssrManage.shareMark"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.shareScore(
                                                  scope.row.markInfo,
                                                  scope.$index,
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Share Score")]
                                        )
                                      : _vm._e(),
                                  ]
                                : undefined
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "roundStatus",
                        label: "Review Outcome",
                        width: "160",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("ic-select", {
                                  attrs: {
                                    disabled: !_vm.canEdit(round),
                                    table: "TT_SSR",
                                    field: "ROUND_SUPPLIER_STATUS",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeRoundSupplierStatus(
                                        scope.row.roundStatus,
                                        scope.$index,
                                        index
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.roundStatus,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "roundStatus", $$v)
                                    },
                                    expression: "scope.row.roundStatus",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        label: "Result communication",
                        width: "200",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.canEdit(round)
                                  ? _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          "show-file-list": false,
                                          action: _vm.supFileUploadAction(
                                            scope.row.ttSsrRoundSupplierId
                                          ),
                                          "on-success": _vm.upload(
                                            index,
                                            scope.$index
                                          ),
                                          headers: _vm.supFileUploadHeaders,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          { attrs: { type: "primary" } },
                                          [_vm._v("upload")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c("file-list", {
                                  attrs: {
                                    "can-edit": _vm.canEdit(round),
                                    files: scope.row.markDocs,
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    !_vm.isSupplier
                      ? _c("el-table-column", {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "comments",
                            label: "Comment",
                            width: "160",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: { disabled: !_vm.canEdit(round) },
                                      model: {
                                        value: scope.row.comments,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "comments", $$v)
                                        },
                                        expression: "scope.row.comments",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticStyle: { "padding-top": "15px" } },
                  [
                    _c("file-upload", {
                      attrs: {
                        disabled: !_vm.canEdit(round),
                        title: "Businsess Recommendation",
                        "rec-type": "SSR",
                        seq: "ROUND_MARK",
                        "biz-id": round.ttSsrRoundId,
                      },
                      model: {
                        value: round.markDocs,
                        callback: function ($$v) {
                          _vm.$set(round, "markDocs", $$v)
                        },
                        expression: "round.markDocs",
                      },
                    }),
                  ],
                  1
                ),
                _vm.canEdit(round)
                  ? _c(
                      "el-row",
                      {
                        staticStyle: { "padding-top": "15px" },
                        attrs: { type: "flex", justify: "center" },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.save("SAVE")
                              },
                            },
                          },
                          [_vm._v("Save As Draft")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.save("SUBMIT")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.submitButton(round)))]
                        ),
                        _vm.canCreateBc
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.createBc()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ssrManage.createBc")))]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e()
      }),
      _vm.canCreateBc
        ? _c(
            "el-row",
            {
              staticStyle: { padding: "15px 0" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save("SUBMIT")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.submitButton(_vm.round)))]
              ),
              _vm.ssr.type == "RFP"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.createBc()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ssrManage.createBc")))]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }